import { applicationChannelName, pusherService } from '$lib/services/pusher';
import { showReleasePrompt } from '$lib/services/release';
import { refreshClientNotifications } from '$lib/stores/client-notifications.store';

// Events the API broadcasts on the app-wide channel
// (see Shared::Banner and VersionUpdated::Service in flowapi).
export const RELEASE_EVENT = 'update';
export const UPDATE_NOTIFICATIONS_EVENT = 'update_notifications';

const onUpdateNotifications = () => void refreshClientNotifications();

// Subscribes once to the app-wide channel and routes its events: a release
// prompts the user to refresh, a banner change re-fetches the banners. Returns
// a function that unbinds both and drops the subscription.
export function watchApplicationChannel(): () => void {
  const channel = pusherService.applicationChannel();
  if (!channel) return () => {};

  channel.bind(RELEASE_EVENT, showReleasePrompt);
  channel.bind(UPDATE_NOTIFICATIONS_EVENT, onUpdateNotifications);

  return () => {
    channel.unbind(RELEASE_EVENT, showReleasePrompt);
    channel.unbind(UPDATE_NOTIFICATIONS_EVENT, onUpdateNotifications);
    pusherService.unsubscribe(applicationChannelName());
  };
}
